import React from 'react'
import { useSelector } from 'react-redux'
import get from 'lodash/get'

import { Text } from '@fielded/shared-ui'

import { selectFinances, selectPayables } from '../../../../root/reducers/retailer/finances'
import { isNewWalletViewEnabled, pluralize } from '../../../../van-shared/utils/utils'
import { getCategorizedPayables } from '../../../../root/reducers/retailer/finances/utils-new'

export const OverdueInfo = ({ isPaused, config }) => {
  const finances = useSelector(selectFinances)
  const payables = useSelector(selectPayables)

  const hasNewWalletView = isNewWalletViewEnabled(config)
  const { overduePayables } = getCategorizedPayables(payables)
  let overduePaymentsCount = overduePayables.length

  if (!hasNewWalletView) {
    const overduePayments = get(finances, 'payables.overduePayments[0]')
    overduePaymentsCount = overduePayments ? overduePayments.transactions.length : 0
  }

  const warningText = (
    <Text>
      Please note that your account will be blocked and deliveries suspended <Text tag='span' bold>if any payment is overdue</Text>. Pay immediately to avoid suspension of service.
    </Text>
  )

  const blockedText = (
    <Text>
      You have <Text tag='span' bold>{overduePaymentsCount} overdue {pluralize('payment', overduePaymentsCount)}.</Text>
    </Text>
  )

  return isPaused ? blockedText : warningText
}
